import type { FaireProductEntity } from "../../entity_types/product";

export const p_muvf4pwzbe: FaireProductEntity = {
  token: "p_muvf4pwzbe",
  type: "product",
  name: "Counter Treats Demo Product",
  brandName: "Theme Demo Brand",
  imageUrl: "/images/placeholder-product.png",
  priceDollars: 12,
  description: "Placeholder product added to satisfy theme token references.",
  categoryTokens: ["cat_proto_theme-demo"],
  tags: ["theme-demo"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-reference-fix",
  },
};
